import { motion } from "framer-motion";
import { Minus, Plus } from "lucide-react";
import { imgSrc } from "../../lib/products";

const Stepper = ({ id, value, set }) => (
  <div className="flex shrink-0 items-center gap-1.5 sm:gap-2">
    {value > 0 && (
      <>
        <button type="button" onClick={() => set(value - 1)} className="qty-btn h-9 w-9" aria-label="Remove one" data-testid={`product-decrease-${id}`}><Minus className="h-4 w-4" /></button>
        <motion.span key={value} initial={{ y: -8, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="w-6 text-center font-display text-xl font-extrabold" data-testid={`product-qty-${id}`}>{value}</motion.span>
      </>
    )}
    <button type="button" onClick={() => set(Math.min(20, value + 1))} className={value ? "qty-btn h-9 w-9" : "btn-gold px-4 py-2 text-sm"} aria-label="Add one" data-testid={`product-increase-${id}`}>
      {value ? <Plus className="h-4 w-4" /> : <><Plus className="h-4 w-4" /> Add</>}
    </button>
  </div>
);

export const ProductPicker = ({ products, cart, setCart, notes, setNotes }) => {
  if (!products.length) return <p className="text-sm text-[var(--sage)]" data-testid="products-loading">Loading products…</p>;
  return (
    <div className="grid gap-3" data-testid="product-picker">
      {products.map((p) => {
        const q = cart[p.id] ?? 0;
        return (
          <div key={p.id} className={`min-w-0 rounded-2xl border p-3 transition-colors ${q ? "border-[#EAB308] bg-[#FEF9E7]" : "border-white/10"}`} data-testid={`product-card-${p.id}`}>
           <div className="flex min-w-0 items-center gap-3 sm:gap-4">
            <img src={imgSrc(p.image)} alt={p.name} className="h-14 w-14 shrink-0 rounded-xl object-cover sm:h-20 sm:w-20" />
            <div className="min-w-0 flex-1">
              <p className="font-display text-lg font-bold leading-tight">{p.name}</p>
              {p.description && <p className="text-xs text-[var(--sage)] sm:text-sm">{p.description}</p>}
              <p className="mt-1 font-semibold text-[var(--gold)]">${Number(p.price ?? 0).toFixed(2)}</p>
            </div>
            <Stepper id={p.id} value={q} set={(v) => setCart({ ...cart, [p.id]: v })} />
           </div>
            {q > 0 && p.note_prompt && (
              <label className="mt-3 block">
                <span className="mb-1.5 block text-sm font-semibold">{p.note_prompt}</span>
                <input value={notes[p.id] ?? ""} onChange={(e) => setNotes({ ...notes, [p.id]: e.target.value })} maxLength={200} placeholder="Type your choice here" className="field bg-white" data-testid={`product-note-${p.id}`} />
              </label>
            )}
          </div>
        );
      })}
    </div>
  );
};
